export interface Perk {
  icon: 'calendar' | 'wrench' | 'shield' | 'headset';
  title: string;
  description: string;
}

export interface BedPart {
  title: string;
  description: string;
}

export interface RateItem {
  name: string;
  kind: string;
  description: string;
  priceLabel: string;
  unitLabel: string;
  href: string;
}

export interface ProcessStep {
  title: string;
  description: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export const PERKS: Perk[] = [
  {
    icon: 'calendar',
    title: 'Rugalmas bérlési idő',
    description: 'Akár néhány napra, akár több hónapra. Hosszabbítani egy telefonhívással lehet.'
  },
  {
    icon: 'wrench',
    title: 'Nem kell szerelnie',
    description: 'Házhoz visszük, összeszereljük, és megmutatjuk a használatát.'
  },
  {
    icon: 'shield',
    title: 'Karbantartott ágyak',
    description: 'Minden ágyat átvizsgálunk, a matracokat bérlés után kimosatjuk.'
  },
  {
    icon: 'headset',
    title: 'Segítőkész ügyfélszolgálat',
    description: 'Kérdése van? Segítünk megtalálni a legjobb megoldást.'
  }
];

export const BED_PARTS_LEFT: BedPart[] = [
  {
    title: 'Kényelmes matrac',
    description: 'A pihentető alvásért. Antidecubitus változatban a felfekvés megelőzésére is.'
  },
  {
    title: 'Állítható háttámla',
    description: 'Kényelmes testhelyzet olvasáshoz, pihenéshez és etetéshez.'
  },
  {
    title: 'Elektromos állítás',
    description: 'Egyszerű vezérlés távirányítóval: magasság, háttámla és lábrész.'
  }
];

export const BED_PARTS_RIGHT: BedPart[] = [
  {
    title: 'Fa véglapok',
    description: 'Otthonos, fa hatású fej- és lábtámla. Nem kórházi hangulat, könnyen lemosható.'
  },
  {
    title: 'Biztonságos oldalrács',
    description: 'Lehajtható mindkét oldalon. Nagyobb biztonság éjszaka is.'
  },
  {
    title: 'Stabil alap, fékezhető kerekek',
    description: 'Könnyű mozgatás takarításkor, majd biztonságos rögzítés a helyén.'
  }
];

export const RATES: RateItem[] = [
  {
    name: 'Elektromos betegágy',
    kind: 'Főeszköz, távirányítóval',
    description:
      'Állítható magasság, háttámla és lábrész. Lehajtható oldalrácsok, fékezhető kerekek. Fekvőfelület 90 × 200 cm, terhelhetőség 150 kg-ig.',
    priceLabel: '29 900 Ft',
    unitLabel: '/ hó',
    href: '/termekek/elektromos-betegagy'
  },
  {
    name: 'Antidecubitus matrac',
    kind: 'Felfekvés megelőzésére',
    description:
      'Váltakozó nyomású, halk kompresszorral, lemosható huzattal. Minden bérlés után szakszerű tisztításon esik át.',
    priceLabel: '12 900 Ft',
    unitLabel: '/ hó',
    href: '/termekek/antidecubitus-matrac'
  },
  {
    name: 'Hagyományos ápolási matrac',
    kind: 'Betegágyhoz méretezve',
    description: 'Vízhatlan, lemosható huzattal, 90 × 200 cm-es méretben, a bérelt ágyhoz illesztve.',
    priceLabel: '6 900 Ft',
    unitLabel: '/ hó',
    href: '/termekek/hagyomanyos-apolasi-matrac'
  },
  {
    name: 'Betegápolási segédeszközök',
    kind: 'Kiegészítők az ágy mellé',
    description:
      'Szoba WC, kapaszkodó, betegemelő, járókeret, infúziós állvány, étkezőasztal. Egy rendelésben, egy címre, egy szállítási díjjal.',
    priceLabel: '2 900 Ft-tól',
    unitLabel: '/ hó, eszközönként',
    href: '/termekek#kiegeszitok'
  }
];

export const PRICE_NOTE =
  'A feltüntetett díjak tájékoztató példaértékek. A végleges bérleti díjakat az egyeztetés után írjuk be – a rendszerben az admin bármikor módosíthatja őket.';

export const PROCESS_STEPS: ProcessStep[] = [
  {
    title: 'Kiválasztja az eszközt',
    description: 'Ágy, matrac és amire még szükség van. Segítünk összeválogatni.'
  },
  {
    title: 'Megadja a címet és az időpontot',
    description: 'Név, telefonszám, cím és a kért nap. A szállítási díjat azonnal látja.'
  },
  {
    title: 'Visszahívjuk és egyeztetünk',
    description: 'Rövid egyeztetés: emelet, lift, fizetési mód, számlaigény.'
  },
  {
    title: 'Kiszállítjuk és beállítjuk',
    description: 'Házhoz visszük, összeszereljük, és megmutatjuk a használatát.'
  }
];

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'Mennyi idő alatt érkezik meg az ágy?',
    answer:
      'Ha az elfogadott megrendelés délelőtt érkezik, jellemzően még aznap kiszállítjuk. Sürgős esetben akár néhány órán belül is tudunk jönni – ilyenkor hívjon minket telefonon.'
  },
  {
    question: 'Kell-e szerelnem az ágyat?',
    answer:
      'Nem. Az ágyat mi visszük fel, mi állítjuk össze, és átadáskor megmutatjuk, hogyan kell használni a távirányítót és az oldalrácsokat.'
  },
  {
    question: 'Mi történik a matraccal két bérlés között?',
    answer:
      'Minden visszaérkezett matracot elszállítunk tisztításra. Amíg a tisztítás nincs elvégezve és rögzítve, a matracot nem adjuk ki új ügyfélnek.'
  },
  {
    question: 'Meddig kell bérelni legalább?',
    answer:
      'Akár néhány napra is bérelhet. Nincs kötelező hosszú futamidő, és a bérlés egy telefonhívással hosszabbítható.'
  },
  {
    question: 'Hogyan fizethetek?',
    answer:
      'Fizethet a helyszínen, átvételkor, illetve online bankkártyával is. A helyszíni fizetést a kiszállító rögzíti a rendszerben, így utólag is visszakereshető.'
  },
  {
    question: 'Kaphatok számlát?',
    answer:
      'Igen. Magánszemélyként és cégként is kérhet számlát – ezt a rendelés leadásakor jelezze, vagy mondja el telefonon.'
  },
  {
    question: 'Mi van, ha elromlik az ágy?',
    answer:
      'Hívjon minket. A bérlés ideje alatt a karbantartás és a javítás a mi feladatunk, díjmentesen. Ha szükséges, cserélünk.'
  },
  {
    question: 'A szolgáltatási területen kívül lakom. Így is bérelhetek?',
    answer: 'Az igényt ilyenkor is leadhatja. Megnézzük, vállalható-e a kiszállítás, és egyedi szállítási díjat adunk rá.'
  }
];

export const COUNTIES = ['Zala vármegye', 'Vas vármegye', 'Somogy vármegye'];

export const NAV_SECTIONS = [
  { href: '#felepites', label: 'Az ágy' },
  { href: '#arak', label: 'Árak' },
  { href: '#folyamat', label: 'Hogyan működik' },
  { href: '#szallitas', label: 'Szállítás' },
  { href: '#gyik', label: 'Kérdések' }
];
